import clsx from 'clsx';
import { graphColors } from "../../services/entity/chart/chart-service";

export const StackedProgressBar = ({ values, maxValue = 100, weights = [], threshold=null, size = 'large', bgColor = 'gray-200', className, ...props }) => {
  if ((weights?.length === 0 || weights.length !== values?.length) && values.length > 0)
    weights = Array(values.length).fill(1);

  const heightClass = size === 'large' ? 'h-4' : 'h-2';
  const bgColorClass = 'bg-' + bgColor;

  const factor = maxValue / values.reduce((accumulator, currentValue, index) => {
    const weightedValue = currentValue * weights[index];
    return accumulator + weightedValue;
  }, 0);

  return (
    <div className={clsx(heightClass, bgColorClass, className, 'flex overflow-hidden rounded-full relative overflow-hidden')}>
      {
        threshold !== null &&
          <div
            className="absolute h-full w-1 -ml-0.5 bg-red-500 z-20"
            style={{ left: threshold + '%' }}
          />
      }
      {
        values.map((value, index) => {
          return (
            <div
              key={index}
              style={{ width: value * weights[index] * factor + '%', background: graphColors[index]}}
              className="ease-linear duration-500 h-full z-10"
            />
          );
        })
      }
    </div>
  );
};
